import { render, staticRenderFns } from "./Ranking2.vue?vue&type=template&id=ecaf43c8&scoped=true"
import script from "./Ranking2.vue?vue&type=script&lang=js"
export * from "./Ranking2.vue?vue&type=script&lang=js"
import style0 from "./Ranking2.vue?vue&type=style&index=0&id=ecaf43c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaf43c8",
  null
  
)

export default component.exports